import { action } from 'satcheljs';
export var messageBeingSent = action('messageBeingSent');
//# sourceMappingURL=messageBeingSent.js.map